import React from 'react';
import PropTypes from 'prop-types';
import { Button } from 'reactstrap';
import { trackEvent } from 'src/util/segment-storeless';

const TrackedButton = (props) => {
  const {
    trackName,
    trackProperties,
    onClick,
    ...domProps
  } = props;

  return (
    <Button
      onClick={() => { trackEvent(trackName, trackProperties, onClick); }}
      {...domProps}
    />
  );
};

TrackedButton.propTypes = {
  trackName: PropTypes.string.isRequired,
  trackProperties: PropTypes.objectOf(
    PropTypes.oneOfType([PropTypes.string, PropTypes.number])
  ).isRequired,
  onClick: PropTypes.func.isRequired,
};

export default TrackedButton;
